export default function Loader() {
  return (
    <div className="flex items-center justify-center">
      <div className="h-6 w-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}
